<form class="form-row pt-3">
  <div class="col-12 col-md-6 col-lg-6">
    <app-date-range-picker [defaultStart]="startDate" [defaultEnd]="endDate" (setRange)="getCustomRange($event)"></app-date-range-picker>
  </div>
  <div class="col-12 col-md-6 col-lg-4">
    <app-dropdown [config]="customSortDropdownConfig" (selectedOption)="onSortOptionChange($event)" [disabled]="false"></app-dropdown>
  </div>
</form>
